const inject = [
   '$location',
   '$rootScope',
   '$state',
   '$stateParams',
   'AuthService',
   'SharedService',
   'ByFavoritesService',
   'SessionService'
];

class AuthController {
   constructor($location, $rootScope, $state, $stateParams, AuthService, SharedService, ByFavoritesService, SessionService) {
      this.$location = $location;
      this.authService = AuthService;
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$stateParams = $stateParams;
      this.sharedService = SharedService;
      this.byFavoritesService = ByFavoritesService;
      this.sessionService = SessionService;
      this.token = this.$stateParams.token;
   }

   $onInit() {
      this.setup();
   }

   setup() {
      if (this.token) {
         this.authService.fetchAuthorization(__env.clientName)
            /* Auth */
            .then((response) => {
               console.log(response);

               const { public_key } = response;

               return this.authService.fetchUser(public_key, this.token);
         })
            /* Login */
            .then((response) => {
               console.log(response);

               if (!response.error) {
                  this.start(response.data);
               } else {
                  this.$rootScope.reloadProyect = true;
                  this.$rootScope.reloadProyectState = 'home.home';
                  this.$state.reload();
               }
            })
            .catch((errors) => {
               console.error(errors);

               this.$rootScope.reloadProyect = true;
               this.$rootScope.reloadProyectState = 'home.home';
               this.$state.reload();
            });
      } else {
         this.$rootScope.reloadProyect = true;
         this.$rootScope.reloadProyectState = 'home.home';
         this.$state.reload();
      }

   }

   start(data) {
      // const CART_ID = this.sessionService.get('cartId') || '';
      this.byFavoritesService.getResumeProductsFavorites(data.userId)
         /* Favorites */
         .then((favorites) => {
            data.favoriteItems = favorites;
            this.sharedService.saveUserLogued(data);

            this.$rootScope.reloadProyect = true;
            this.$rootScope.reloadProyectState = 'home.cart';
            this.$state.reload();
         })
   }
}

AuthController.$inject = inject;

export default AuthController;


// WEBPACK FOOTER //
// ./www/components/auth/auth.controller.js